import { SVGProps } from "react";

export function RubleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="48" height="48" rx="24" fill="#E7E7E7" />
      <path
        d="M18.9127 15.917H26.339C27.8932 15.917 29.0628 16.3576 29.8479 17.2389C30.649 18.1041 31.0495 19.3057 31.0495 20.8439C31.0495 22.3339 30.649 23.4875 29.8479 24.3046C29.0628 25.1218 27.8932 25.5303 26.339 25.5303H21.4362V32.5H18.9127V15.917ZM28.478 21.0842V20.5555C28.478 19.7704 28.2697 19.1535 27.8531 18.7049C27.4365 18.2402 26.7636 18.0079 25.8343 18.0079H21.4362V23.6077H25.8343C26.7636 23.6077 27.4365 23.3754 27.8531 22.9107C28.2697 22.4461 28.478 21.8372 28.478 21.0842ZM16.6055 25.5303V23.6077H21.0036V25.5303H16.6055ZM16.6055 29.0632V27.2848H27.6128V29.0632H16.6055Z"
        fill="#7A7A7A"
      />
    </svg>
  );
}
